import { configureStore, combineReducers, Action } from "@reduxjs/toolkit";

import authReducer from "./features/authSlice";

import userReducer from "./features/userSlice";

import ibanInvoiceReducer from "./features/ibanInvoiceSlice";
import ibanInvoiceDetailsReducer from "./features/ibanInvoiceDetailsSlice";
import ibanAccountReducer from "./features/ibanAccountSlice";

import bankIntegrationsReducer from "./features/bankIntegrationsSlice";
import invoiceExpirationSettingsReducer from "./features/invoiceExpirationSettingsSlice";
import clientApiKeyReducer from "./features/clientApiKeySlice";

import subscriptionReducer from "./features/subscriptionSlice";

import ibanInvoicePaymentReducer from "./features/ibanInvoicePaymentSlice";
import publicIbanQrReducer from "./features/publicIbanQrSlice";
import preOrderReducer from "./features/preOrderSlice";
import homeReducer from "./features/homeSlice";

import notificationReducer from "./features/notificationSlice";
import loadingReducer from "./features/globalLoadingSlice";
import modalReducer from "./features/modalSlice";

import { ActionTypes } from "./actionTypes";

const rootReducer = combineReducers({
  auth: authReducer,

  user: userReducer,

  ibanInvoice: ibanInvoiceReducer,
  ibanInvoiceDetails: ibanInvoiceDetailsReducer,
  ibanAccount: ibanAccountReducer,
  invoiceExpirationSettings: invoiceExpirationSettingsReducer,
  clientApiKey: clientApiKeyReducer,
  bankIntegrations: bankIntegrationsReducer,

  subscription: subscriptionReducer,

  publicIbanQr: publicIbanQrReducer,
  ibanInvoicePayment: ibanInvoicePaymentReducer,
  preOrder: preOrderReducer,
  home: homeReducer,

  notification: notificationReducer,
  loading: loadingReducer,
  modal: modalReducer,
});

export const store = configureStore({
  reducer: (
    state: ReturnType<typeof rootReducer> | undefined,
    action: Action,
  ) => {
    if (action.type === ActionTypes.RESET_STORE) {
      state = undefined;
    }

    return rootReducer(state, action);
  },
  devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
